import React from 'react';

interface CustomOverridenSigninScreenProps {
    RenderComponent?: React.FC;
}

const CustomOverridenSigninScreen: React.FC<CustomOverridenSigninScreenProps> = ({
    RenderComponent,
}) => {
    return RenderComponent ? <RenderComponent /> : null;
};

export default CustomOverridenSigninScreen;
